export default __webpack_public_path__ + "static/media/illus11.fbedbb7f.png";